import React,{Component} from 'react'

import Utility from '../utility'
import Equipments from './equipments';
import Sidebar from './sidebar';
import {constants} from "../constants";
class Drawing extends Component{

    constructor(props){
        super(props);

        this.state={
            points:[],
        }
        this.onChange=this.onChange.bind(this);
        this.showCard=this.showCard.bind(this);
        this.select = this.select.bind(this);
        this.sendValue = this.sendValue.bind(this);
        this.drawLine = this.drawLine.bind(this);
        this.deleteLine = this.deleteLine.bind(this);
        this.drawObject = this.drawObject.bind(this);
    }

    onChange(e){
        let element=e.target ,
            type=element.getAttribute('data-type');

        if(type){
            this.setState({[type]:element.value});
        }
    }

    showCard(e){
        let element=e.target,
            target=element.getAttribute('data-target');

        document.querySelector(target).classList.toggle('show');
    }

    select(e, type = "equipment") {
        let element = e.target;
        if (element.nodeName === "IMG") { //check clicked tag
            element = element.closest('div');
        }
        let url = element.children[0].src,
            name = element.getAttribute('data-name'),
            active = parseInt(element.getAttribute('data-key')),
            activeKey = "currentEquipment";

        if (type === "product") {
            activeKey = "currentProduct";
        }

        if (name) {
            this.setState({ [type]: name, [type + "Url"]: url, [activeKey]: active });
        }
    }

    sendValue(){
        let d=Utility.objectCopy(this.state);
        delete d['equipments'];
        this.props.save(d,"drawing");
        return this.props.history.push('/');
    }

    drawLine(){
        if(window.addLineOnAngle){

            let angle = parseFloat(document.getElementById('angle').value),
                length = parseFloat(document.getElementById('width').value);
            if(angle && length){
                this.setState({points:[...this.state.points,{angle,length}]})
                window.addLineOnAngle()
            }
        }
    }

    deleteLine(){
        if(window.deleteLines){
            window.deleteLines()
            let arr = this.state.points;
            let newarr = [...arr];
            newarr.splice(arr.length-1, 1);
            this.setState({points:newarr})
        }
    }

    drawObject(){
        if(window.changeSecond){
            window.changeSecond();
        }
    }


    render(){
        return (
            <React.Fragment>
                <div className="content-side col-lg-8 col-md-12 col-sm-12">
                    <div id="drawing-container" className="mb-5">

                    </div>
                    <div className="canvas-controls mb-5">
                        <div className="align-items-end row">
                            <div className="col-md-4 col-sm-12">
                                <label htmlFor="texture">Select Texture</label>
                                <select id="texture" className="form-control" defaultValue="red">
                                    <option value="red">Red</option>
                                    <option value="green">Green</option>
                                    <option value="blue">Blue</option>
                                </select>
                            </div>
                            <div className="col-md-4 col-sm-12">
                                <button className="theme-btn btn-style-two small" onClick={this.drawObject}>Create 3D</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Here we don't need proxy */}
                <Sidebar resetEdit={this.props.resetEdit} deleteLine={this.deleteLine} drawLine={this.drawLine} proxyClick={this.sendValue} id={this.props.id} type="individual" data={this.state} name={"Individuell Nr."+this.props.id} />
            </React.Fragment>
        )
    }
}

export default Drawing;
